import {Pipe, PipeTransform} from '@angular/core';
import {IEnquiryListRespData} from '../model/IEnquiryListResp';
import appUtil from 'src/app/shared/util/app.util';
import {RouteEnum} from 'src/app/shared/constants/route.enum';
import {AppPrincipalService} from 'src/app/shared/service/principal/app-principal.service';

@Pipe({
  name: 'buildEnquiryLink',
  standalone: true,
})
export class BuildEnquiryLinkPipe implements PipeTransform {
  constructor(private readonly principalSvc: AppPrincipalService) {}

  transform(value: string): string {
    if (appUtil.isEmpty(value)) {
      return '';
    }
    return `${RouteEnum.DELAER_ENQ_DETAILS_ROUTE_PATH}/${value}/${btoa(this.principalSvc.getMspin())}}`;
  }
}
